import { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";

// Direct APK download endpoint. Never rendered as visible text in the UI.
export const APK_DOWNLOAD_URL =
  "https://awadhcrypto.in/api/public/exchange/dt-adda/download-apk";

const DownloadContext = createContext(null);

export const isAndroidDevice = () =>
  typeof navigator !== "undefined" && /android/i.test(navigator.userAgent);

export function DownloadProvider({ children }) {
  const [qrOpen, setQrOpen] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const timer = useRef(null);

  const triggerFileDownload = useCallback(() => {
    const anchor = document.createElement("a");
    anchor.href = APK_DOWNLOAD_URL;
    anchor.download = "CoinAdda.apk";
    anchor.rel = "noopener";
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  }, []);

  const startDownload = useCallback(() => {
    if (isAndroidDevice()) {
      setDownloading(true);
      triggerFileDownload();
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setDownloading(false), 3000);
    } else {
      setQrOpen(true);
    }
  }, [triggerFileDownload]);

  const value = useMemo(
    () => ({ startDownload, triggerFileDownload, downloading, qrOpen, setQrOpen }),
    [startDownload, triggerFileDownload, downloading, qrOpen]
  );

  return <DownloadContext.Provider value={value}>{children}</DownloadContext.Provider>;
}

export function useDownload() {
  const ctx = useContext(DownloadContext);
  if (!ctx) throw new Error("useDownload must be used within DownloadProvider");
  return ctx;
}
